var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"contents"}},[_c('button',{staticClass:"btn scanner fixed",attrs:{"type":"button"},on:{"click":function($event){return _vm.scanqr()}}},[_c('i',{staticClass:"fas fa-qrcode fa-2x"})])])}
var staticRenderFns = []

export { render, staticRenderFns }